import isEmpty from 'lodash/isEmpty';

import { getAverageDailyRate } from '../../campaign-editor/utils';
import { isOnsite } from '../../products/utils';
import { calculateSpendableBudgetFromQL } from './calculate-derived-values';

export function getExpectedCampaignLines(line, serviceValue) {
  const sharesPerCountry = Object.values(line.countrySplit)
    .filter(share => share > 0)
    .map(share => share * serviceValue);

  return sharesPerCountry.reduce((lines, countryShare) => {
    if (isEmpty(line.genders)) {
      lines.push({
        budget: countryShare,
        startDate: line.startDate,
        endDate: line.endDate,
      });
    }

    line.genders.forEach(key =>
      lines.push({
        budget: countryShare * line[`gender${key}Share`],
        startDate: line.startDate,
        endDate: line.endDate,
      }),
    );
    return lines;
  }, []);
}

export function getOnsiteAverageDailyRate(quote, quoteLinesById, productsById) {
  const onsiteLines = quote.quoteLines
    .map(id => quoteLinesById[id])
    .filter(line => isOnsite(productsById[line.productId]));

  if (!onsiteLines.length) {
    return null;
  }

  const onsiteCampaignLines = onsiteLines.flatMap(line => {
    const serviceValue = calculateSpendableBudgetFromQL(
      line,
      quote.headerDiscountPercent,
    );
    return getExpectedCampaignLines(line, serviceValue);
  });

  return getAverageDailyRate(onsiteCampaignLines);
}
